import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { ChildrenProp } from '../declarations/ChildrenProp';
import Container from './Container';
import SaveFormButton from './SaveFormButton';

export interface SettingsViewHeaderProps extends ChildrenProp {
  title: string;
  saveButtonInHeader?: boolean;
}

export const SettingsViewHeader: FC<SettingsViewHeaderProps> = ({ title, saveButtonInHeader }) => {
  return (
    <Container fullWidth spaceBetween>
      <Typography variant='h1' sx={{ my: 2, fontSize: 'xx-large' }}>
        {title}
      </Typography>

      {saveButtonInHeader && (
        <Container
          sx={{
            position: 'fixed',
            zIndex: '10',
            top: '100px',
            right: '50px',
            backgroundColor: '#efefef',
            padding: '1em',
          }}>
          <SaveFormButton />
        </Container>
      )}
    </Container>
  );
};

export default SettingsViewHeader;
